import { Component, Inject, inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageUploadService } from '@services/image-upload.service';

@Component({
	selector: 'app-new-receipt-image',
	templateUrl: './new-receipt-image.component.html',
	styleUrls: ['./new-receipt-image.component.scss'],
})
export class NewReceiptImageComponent {
	private _imageService = inject(ImageUploadService);
	private dialogRef = inject(MatDialogRef<NewReceiptImageComponent>);

	imagePrefix = this.data?.prefix || '';
	uploadImageCallback = this._imageService.uploadImageToServer.bind(this._imageService);

	constructor(@Inject(MAT_DIALOG_DATA) private data: { prefix: string }) {}

	onNoClick(): void {
		this.dialogRef.close();
	}
}
